(function () {
  "use strict";

  brandBodyColor.$inject = ['$location', 'mtypes', 'accountInfoService'];
  angular
    .module('branding')
    .directive('brandBodyColor', brandBodyColor);

  function brandBodyColor($location, mtypes, accountInfoService) {
    return {
      restrict: 'A',
      templateUrl: 'pages/branding/template/bodyColor.html',
      transclude: true,
      replace: true,
      require: ['ngModel', '^brandCrud'],
      scope: {
        colorOptions: '=brandBodyColor',
        colorChanged: '&'
      },
      link: function (scope, element, attrs, ctrls) {
        if (!ctrls)
          return;

        var ngModel = ctrls[0];
        var crud = ctrls[1];

        scope.$watch(function () {
          return ngModel.$modelValue;
        }, function (modelValue) {
          if (scope.bodyColorModel == modelValue)
            return;

          scope.bodyColorModel = modelValue;
        });

        scope.$watch('bodyColorModel', function (newValue, oldValue) {
          if (newValue === null || newValue === undefined)
            return;

          ngModel.$setViewValue(newValue);

          scope.colorChanged({color: newValue});

          if (crud.resetting || newValue == oldValue)
            ngModel.$setPristine(true);

          crud.setDirty(ngModel.$dirty);
        });

        scope.showFeatureUpgrade = function () {
          accountInfoService.openNewWindow();
        };
      }
    };
  }

})();
